import { z } from 'zod'
import { stringSchema } from './common'

export const utmKeys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const

export type UtmKey = (typeof utmKeys)[number]

export const utmSchema = z
  .object({
    utm_source: stringSchema.min(1).nullish(),
    utm_medium: stringSchema.min(1).nullish(),
    utm_campaign: stringSchema.min(1).nullish(),
    utm_content: stringSchema.min(1).nullish(),
    utm_term: stringSchema.min(1).nullish(),
  })
  .transform((value) => {
    return Object.fromEntries(
      Object.entries(value).filter(([, entry]) => typeof entry === 'string' && entry.trim() !== ''),
    )
  })

export type UtmData = z.infer<typeof utmSchema>
